import {
  Paragraph,
  SectionType,
  TextRun,
  TabStopType,
  TabStopPosition,
  Tab,
  HeadingLevel,
  ISectionOptions,
} from 'docx'
import highlights from '../common/highlights'
import dateRange from '../common/dateRange'
import { Resume } from '@/types/resume/v1'

const volunteer = ({ volunteer }: Resume.Schema): ISectionOptions => {
  return {
    properties: {
      type: SectionType.CONTINUOUS,
    },
    children: [
      new Paragraph({
        text: '\n',
      }),
      new Paragraph({
        text: 'Volunteer',
        heading: HeadingLevel.HEADING_2,
      }),
      ...volunteer.reduce<Paragraph[]>((acc, volunteerItem) => {
        return [...acc, ...createVolunteerItem(volunteerItem)]
      }, []),
    ],
  }
}

const createVolunteerItem = (volunteerItem: Resume.Volunteer): Paragraph[] => {
  const item: Paragraph[] = []
  item.push(
    new Paragraph({
      text: '\n',
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: volunteerItem.position,
          bold: true,
        }),
        new TextRun({
          children: [new Tab()],
        }),
        new TextRun({
          text: dateRange(volunteerItem.startDate, volunteerItem.endDate, true),
        }),
      ],
      tabStops: [
        {
          type: TabStopType.RIGHT,
          position: TabStopPosition.MAX,
        },
      ],
    })
  )
  item.push(
    new Paragraph({
      children: [
        new TextRun({
          text: volunteerItem.organization,
          italics: true,
        }),
      ],
    })
  )
  if (volunteerItem.summary) {
    item.push(
      new Paragraph({
        text: '\n',
      })
    )
    item.push(
      new Paragraph({
        text: volunteerItem.summary,
      })
    )
  }
  item.push(...highlights(volunteerItem.highlights))
  return item
}

export default volunteer
